import { useDispatch } from "react-redux";
import { useCallback } from "react";
import requestLanguageChange from "./thunks/changeLanguage";
import { LangCode } from "../../requests/localization/types";

// eslint-disable-next-line import/prefer-default-export
export const useChangeLanguage = () => {
  const dispatch = useDispatch();
  return useCallback(
    (newLocale: string) => {
      dispatch(requestLanguageChange(newLocale as LangCode));
    },
    [dispatch]
  );
};
